import Authorities from '@/types/Authority';
import { getAuthCodeAndRedirect } from '@/utils/functions/getAuthCodeAndRedirect';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Col, Popover, Button, message } from 'antd';
import { ExternalLink } from 'react-feather';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { Group } from '@/components/_common';
import { useWorkOrderComplementGenerateActivity } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';

export default function ComplementHeaderGP() {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const generateActivity = useWorkOrderComplementGenerateActivity();

  const hasGPPermission = hasPermissions([Authorities.YARDMANAGEMENT]);
  const hasGPFollowUpCreatePermission = hasPermissions([
    Authorities.YARDMANAGEMENT_FOLLOWUP_CREATE_ACTIVITY,
  ]);

  const handleGenerateActivity = async () => {
    try {
      if (workorder && complement) {
        if (!complement.estimatedLeaveDate) {
          return message.warn(
            'É necessário informar a data de saída prevista',
            5,
          );
        }

        await generateActivity.mutateAsync({
          complementId: complement?.id,
          workOrderId: workorder.id,
        });
      }
    } catch {}
  };

  return (
    <>
      {!!complement?.activityId && hasGPPermission ? (
        <Col>
          <Popover content="Acessar Gestão de Pátio">
            <Button
              onClick={() =>
                getAuthCodeAndRedirect(
                  `${process.env.REACT_APP_GP_URL}/panel/accompaniment?activityId=${complement.activityId}`,
                  '_blank',
                  {
                    destinationUrl: process.env.REACT_APP_GP_URL + '/auth-code',
                  },
                )
              }
            >
              <Group gap={8}>
                <span>Atividade</span>
                <ExternalLink size={14} style={{ margin: 0 }} />
              </Group>
            </Button>
          </Popover>
        </Col>
      ) : (
        <Col>
          <Button
            onClick={handleGenerateActivity}
            loading={generateActivity.isLoading}
            disabled={!hasGPPermission || !hasGPFollowUpCreatePermission}
          >
            Gerar Atividade
          </Button>
        </Col>
      )}
    </>
  );
}
